exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-app-account-delete-js": () => import("./../../../src/pages/app-account-delete.js" /* webpackChunkName: "component---src-pages-app-account-delete-js" */),
  "component---src-pages-betreuungsfragebogen-js": () => import("./../../../src/pages/betreuungsfragebogen.js" /* webpackChunkName: "component---src-pages-betreuungsfragebogen-js" */),
  "component---src-pages-register-js": () => import("./../../../src/pages/register.js" /* webpackChunkName: "component---src-pages-register-js" */)
}

